import { Component, EventEmitter, Input, Output, Inject, OnInit } from '@angular/core';

// constants\
import { MOBILE_CONSTANTS } from '@open-portal-app/core/constants/mobile.constants';

@Component({
  selector: 'app-mobile-policy',
  templateUrl: './mobile-policy.component.html',
  styleUrls: ['./mobile-policy.component.scss']
})
export class MobilePolicyComponent {
  @Input() policyDetails!: {[key: string]: any}
  @Output() updatePolicyPage = new EventEmitter<any>();

  faq:{[key: string]: any} = {}; 
  region: string = this.environment.region;

  constructor(
    @Inject('environment') public environment: any
  ) { }

  ngOnInit() {
    const partner = this.policyDetails.partnerSlug;
    if (MOBILE_CONSTANTS[partner][this.region]) {
      this.faq = {
        url: MOBILE_CONSTANTS[partner][this.region].faq,
        label: MOBILE_CONSTANTS[partner][this.region].label
      };
    }
  }

  notifyPolicyPage() {
    this.updatePolicyPage.emit();
  }
}
